export default __webpack_public_path__ + "static/media/KTH_8.e1fa0ef4.jpg";